import { useQuery } from '@tanstack/react-query';
import apiClient from '../libs/apiClient';
import { useUserContext } from '../providers/UserProvider';
import { ApiResponse } from '../types/response';
import { Document } from '../types/session';
import { getDocumentUploadProgress } from '../utils/documentUtil';

export const useGetDocuments = (sessionId: number) => {
  const { setDocumentUploadStatus } = useUserContext();

  return useQuery({
    queryKey: ['session', sessionId, 'documents'],
    queryFn: async () => {
      const { data: responseData } = await apiClient.get<ApiResponse<Document[]>>(`session/${sessionId}/documents`);

      if (responseData.data) {
        const { data: documents } = responseData;
        const documentUploadStatus = getDocumentUploadProgress(documents);
        setDocumentUploadStatus(documentUploadStatus);
      }

      return responseData.data;
    },
    staleTime: Infinity,
    enabled: sessionId ? true : false,
  });
};
